// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/check.js';

import { paths } from '../generated/check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('check', Original, paths);
